import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/foodOperator/importer/foodOperatorImporterActions';

export default importerReducers(actions);
